<!-- eslint-disable vue/no-v-html -->
<template lang="">
  <div class="card">
    <div class="card-body">
      <div class="card-title text-secondary">Búsquedas populares</div>
      <div class="d-flex flex-row flex-wrap gap-2">
        <div
          v-for="suggest in mostSearched"
          :key="suggest.sentence"
          class="border border-danger-subtle rounded-pill py-1 px-2"
        >
          <router-link
            class="link-underline link-underline-opacity-0 px-1"
            :to="getUrl(suggest)"
            @click="closeSuggestions()"
          >
            <span
              class="text-nowrap text-truncate fs-7 text-secondary"
              v-html="sentenceStyle(suggest.sentence)"
            ></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import eventBus from "~/event-bus";
import { getTitleTranslate, getFinalEshopUrl } from "@/utils/general";
import useSearchStore from "~/stores/search";

export default {
  props: {
    mostSearched: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: ["close-suggestions"],
  data: () => ({
    searchStore: useSearchStore(),
  }),
  methods: {
    getFinalUrl(path: string) {
      return getFinalEshopUrl(path);
    },
    sentenceStyle(sentence: string) {
      const words = sentence.split(" ");
      if (words[0]) {
        words[0] = '<span class="fw-semibold">' + words[0] + "</span>";
      }
      return words.join(" ");
    },
    getTitle(section: string, name: string) {
      return getTitleTranslate(section, name);
    },
    getUrl({ sentence }: { sentence: string }) {
      return { name: "search", params: { filters: ["t_" + toSlug(sentence)] } };
    },
    closeSuggestions() {
      eventBus.emit("close-suggestions");
    },
  },
};
</script>

<style lang=""></style>
